import { hrApiClient } from '@/lib/api/clients';
import { FooterDataItem } from '@/shared';

export async function getFooter(): Promise<FooterDataItem[]> {
  const response = await hrApiClient.get('/data/footer');
  return response.data || [];
}
